import React from 'react'

import { Panel, Spinner } from '@pb/components'

import EmptyMessages from '../EmptyMessages'
import FailedMessages from '../FailedMessages'
import MessageContent from '../MessageContent'
import styles from './InboxContent.scss'

const InboxContent: React.FC<any> = ({
  messages,
  messagesIsLoading,
  messagesHasLoaded,
  messagesError,
}) => (
  <div className={styles.container}>
    {messagesIsLoading && (
      <Panel>
        <Spinner isRendered={messagesIsLoading} />
      </Panel>
    )}
    {messagesHasLoaded && messages.length > 0 && <MessageContent messages={messages} />}
    {!messagesError && messagesHasLoaded && messages.length === 0 && <EmptyMessages />}
    {messagesError && <FailedMessages />}
  </div>
)

export default InboxContent
